// Porta leve do módulo para `src/app` e `src/routes` (JS inicial): manifestos, schemas de busca e o
// catálogo. As telas saem por `loadPersonScreens`, carregadas sob demanda pela rota (S17).
export { loadPersonMessages } from './person.catalog';
export {
  legalPersonListScreen,
  legalPersonPendingScreen,
  naturalPersonListScreen,
  naturalPersonPendingScreen,
} from './person-list.screen';
export { legalPersonListSearch, naturalPersonListSearch } from './person.search';
export { legalPersonDetailScreen, naturalPersonDetailScreen, PERSON_PATH_TABS, personDetailSearch, type PersonTab } from './person-detail.screen';

/** As telas, carregadas sob demanda pela rota. */
export const loadPersonScreens = () => import('./screens');

/** Os guias das telas para o Luy (U46), sob demanda. */
export const loadPersonGuides = () => import('./person.guide');
